module.exports = __webpack_public_path__ + "static/nokia-1-d85ff8ce79b6c0d888790038784aea3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/nokia/nokia-1.jpg
// module id = 413
// module chunks = 3627797113349 20562973939449 33019919093843